import computeClassName from '../../../../../../utils/computeClassName';
import defaultToIfFalsy from '../../../../../../utils/defaultToIfFalsy';
// TODO: configure 'fill' and 'stroke' in tailwind.config.js
// Refer to: https://tailwindcss.com/docs/stroke#customizing
const propsDefaults = Object.freeze({
  className: '',
  fill1ClassName: 'fill-cc-gray-dark',
  fill2ClassName: 'fill-cc-white'
});

export default function CCIconWarningSolid16x16(
  {
    className = propsDefaults.className,
    fill1ClassName = propsDefaults.fill1ClassName,
    fill2ClassName = propsDefaults.fill2ClassName
  }) {
  const computedClassName = computeClassName(className, '');
  const computedFill1ClassName = computeClassName(defaultToIfFalsy(fill1ClassName, propsDefaults.fill1ClassName), '');
  const computedFill2ClassName = computeClassName(defaultToIfFalsy(fill2ClassName, propsDefaults.fill2ClassName), '');
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <g clipPath="url(#CCIconWarningSolid16x16_clip0)">
        <path d="M7.076 0.728009L0.674995 12.862C0.555285 13.074 0.491487 13.313 0.489606 13.5565C0.487725 13.7999 0.547822 14.0399 0.664243 14.2537C0.780663 14.4676 0.949577 14.6483 1.15509 14.7788C1.3606 14.9094 1.59595 14.9855 1.839 15H14.639C14.882 14.9855 15.1174 14.9094 15.3229 14.7788C15.5284 14.6483 15.6973 14.4676 15.8137 14.2537C15.9302 14.0399 15.9903 13.7999 15.9884 13.5565C15.9865 13.313 15.9227 13.074 15.803 12.862L9.39999 0.728009C9.29187 0.512468 9.12593 0.331247 8.92073 0.204606C8.71552 0.0779644 8.47913 0.0108948 8.238 0.0108948C7.99686 0.0108948 7.76047 0.0779644 7.55526 0.204606C7.35006 0.331247 7.18412 0.512468 7.076 0.728009Z" fill="#1B1C1D" className={computedFill1ClassName}/>
        <path d="M8.24097 13C8.79325 13 9.24097 12.5523 9.24097 12C9.24097 11.4477 8.79325 11 8.24097 11C7.68868 11 7.24097 11.4477 7.24097 12C7.24097 12.5523 7.68868 13 8.24097 13Z" fill="white" className={computedFill2ClassName}/>
        <path d="M9.24097 4C9.24097 3.44772 8.79325 3 8.24097 3C7.68868 3 7.24097 3.44772 7.24097 4V8.7C7.24097 9.25228 7.68868 9.7 8.24097 9.7C8.79325 9.7 9.24097 9.25228 9.24097 8.7V4Z" fill="white" className={computedFill2ClassName}/>
      </g>
      <defs>
        <clipPath id="CCIconWarningSolid16x16_clip0">
          <rect width="15.481" height="15" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
